import { createContext } from 'react';
import { themeType } from './themeType';

const themeContext = createContext({} as themeType);

export default themeContext;
